import * as React from 'react';

import './styles/header.css';

export const HeaderTopText = ({text, color}) => {
    return (
        <h6 className='header-top-text' style={{color}}>{text}</h6>
    )
}